import { IsOptional, IsString } from 'class-validator';

import { CrudItemListRequest } from '../crud';

export class WidgetGetListRequest extends CrudItemListRequest {
    @IsOptional()
    @IsString()
    public search?: number | string;

    constructor(data?: Partial<WidgetGetListRequest>) {
        super(data);
        this.search = data && data.search;
    }
}
